import React from 'react'
import { RichText } from '../richTextOptions';
import { Image } from './Common/Image';

const ContentfulBlockStateCondition = (props) => {
    const {
        conditionIcon,
        conditionName,
        conditionDescription,
        conditionColor
    } = props;
    let containerClass = 'state-condition';

    return (
        <div className={containerClass}>
            <div className="headline-wrapper" style={{'color': conditionColor}}>
                <Image image={conditionIcon} />
                {conditionName && <h3>{conditionName}</h3>}
            </div>
            {conditionDescription && <RichText data={conditionDescription} />}
        </div>
    )
}

export { ContentfulBlockStateCondition };
